import { memo, useCallback, useMemo } from 'react';

import { OnOffShareToggleRow } from '~/components/ShareModal/components/OnOffShareToggleRow';
import { ToggleInfoTooltip } from '~/components/ShareModal/components/ToggleInfoTooltip';
import { useShowcaseModal } from '~/components/ShowcaseModal/ShowcaseModalContext';

/** Create-mode smart leaf: disable-expanding-nested-content toggle. Writes draft state, no per-change analytics. */
export const CreateShowcaseSettingsDisableExpandNestedRow = memo(() => {
  const { shortUrlProps, isSaving, updateLockedControlsExpandNested } = useShowcaseModal();

  const isExpandNestedDisabled = useMemo(
    () => shortUrlProps.presentationSettings?.lockedControls?.expandNested === true,
    [shortUrlProps.presentationSettings?.lockedControls?.expandNested],
  );

  const handleToggleDisableExpandNested = useCallback(
    (checked: boolean) => {
      updateLockedControlsExpandNested(checked);
    },
    [updateLockedControlsExpandNested],
  );

  return (
    <OnOffShareToggleRow
      label="Disable expanding nested content"
      labelAccessory={<ToggleInfoTooltip text="Prevent viewers from expanding nested content" />}
      checked={isExpandNestedDisabled}
      isLoading={isSaving}
      onToggle={handleToggleDisableExpandNested}
      data-testid="DISABLE_EXPAND_NESTED_TOGGLE"
    />
  );
});

CreateShowcaseSettingsDisableExpandNestedRow.displayName = 'CreateShowcaseSettingsDisableExpandNestedRow';
